module.exports = __webpack_public_path__ + "img/signup-bg3.a2b28675.png";